document.addEventListener('click', event => {
  document.querySelectorAll('.me-disclosure[open]').forEach(menu => {
    if (!menu.contains(event.target)) menu.open = false;
  });
});
document.addEventListener('keydown', event => {
  if (event.key !== 'Escape') return;
  const active = document.activeElement;
  document.querySelectorAll('.me-disclosure[open]').forEach(menu => {
    menu.open = false;
    if (menu.contains(active)) menu.querySelector('summary').focus();
  });
});
